<template>
  <div>
    <div style="text-align: right; margin: 10px 0;">
      <el-button type="primary" size="mini" icon="el-icon-edit" @click="toComment">添加评论</el-button>
    </div>
    <div class="comment-list">
      <div class="comment-item" v-for="(comment, index) in commentList" :key="index">
        <!-- 用户信息 -->
        <div class="comment-header">
          <div class="user-name">{{ comment.userName }}</div>
          <div class="user-meta">
            <div class="user-date">{{ $date.formatTimestamp('date', comment.createTime) }}</div>
          </div>
        </div>

        <!-- 评论内容 -->
        <div class="comment-body">
          <p class="comment-text">{{ comment.content }}</p>
          <el-rate v-model="comment.score" disabled show-score text-color="#ff9900"></el-rate>
          <div class="comment-right" v-if="comment.isOwner">
            <span style="color: #666;" v-if="comment.status === 0">{{statusList[comment.status]}}</span>
            <span style="color: #3dbd52;" v-if="comment.status === 1">{{statusList[comment.status]}}</span>
            <span style="color: #d40000;" v-if="comment.status === 2">{{statusList[comment.status]}}</span>
            <span class="delete-btn" @click="deleteComment(comment)">删除</span>
          </div>
        </div>
      </div>

      <div class="paginationArea" style="text-align: center; margin-top: 5px">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" @size-change="form.pageSize = $event, getUserByPage()"
          @current-change="form.pageNum = $event, getUserByPage()" :page-size="form.pageSize" :total="form.total" :page-sizes="[20, 50, 100, 300]"
          :current-page="form.pageNum"></el-pagination>
      </div>
    </div>

    <el-dialog title="添加评论" :visible.sync="commentDialog" width="40%">
      <div v-if="commentDialog">
        <div class="login-box">
          <el-form :model="comment" ref="form" label-width="80px" @keyup.enter.native="addComment">
            <el-form-item label="评分">
              <div style="padding: 10px;">
                <el-rate v-model="comment.score"></el-rate>
              </div>
            </el-form-item>
            <el-form-item label="评论内容">
              <el-input type="textarea" v-model="comment.content" placeholder="请输入评论内容" :rows="6"></el-input>
            </el-form-item>
            <el-form-item>
              <div style="text-align: right;">
                <el-button type="primary" @click="addComment()">确定</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['obj'],
  data () {
    return {
      commentDialog: false,
      statusList: { 0: '待审核', 1: '审核通过', 2: '审核不通过' },
      comment: {},
      commentList: [],
      form: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  created () {
    this.getCommentByPage()
  },
  methods: {
    deleteComment (comment) {
      this.$confirm(() => {
        this.$http.post('/comment/service/deleteComment', comment).then((res) => {
          this.$message.success('删除成功')
          this.getCommentByPage()
        })
      }, '请确认该操作是否执行？')
    },
    toComment () {
      if (!this.$cookie.get('YZSNAME')) {
        this.$emit('login')
      } else {
        this.commentDialog = true
      }
    },
    getCommentByPage () {
      this.form.objId = this.obj.id
      this.form.objType = this.obj.type
      this.form.objName = this.obj.name
      this.$http.post('/comment/service/getUserCommentByPage', this.form).then((res) => {
        const cookieId = this.$cookie.get('YZSUSERID')
        if (cookieId) {
          const userId = parseInt(cookieId)
          res.data.dataList.forEach(item => {
            if (item.userId === userId) {
              item.isOwner = true
            } else {
              item.isOwner = false
            }
          })
        }
        this.commentList = res.data.dataList
        this.form.total = res.data.total
      })
    },
    addComment () {
      this.comment.objId = this.obj.id
      this.comment.objType = this.obj.type
      this.comment.objName = this.obj.name
      this.$http.post('/comment/service/addComment', this.comment).then((res) => {
        this.$message.success('评论成功')
        this.commentDialog = false
        this.getCommentByPage()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.comment-list {
  margin-top: 20px;

  .comment-item {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .comment-header {
      margin-bottom: 12px;
      position: relative;
      .user-name {
        font-weight: 600;
        font-size: 14px;
        color: #333;
      }
      .user-meta {
        position: absolute;
        top: 0;
        right: 0;
        .user-date {
          font-size: 12px;
          color: #999;
          margin-top: 2px;
        }
      }
    }

    .comment-body {
      position: relative;
      .comment-text {
        font-size: 14px;
        line-height: 1.6;
        color: #444;
        margin-bottom: 10px;
      }

      .comment-right {
        position: absolute;
        bottom: 0;
        right: 0;
        font-size: 12px;
        .delete-btn {
          margin-left: 20px;
          font-size: 12px;
          color: #a73939;
          cursor: pointer;
          user-select: none;
          &:hover {
            color: #d40000;
          }
          &:active {
            color: #a73939;
          }
        }
      }
    }
  }
}
</style>
